module.exports = __webpack_public_path__ + "img/45_11.d4f2832d.png";